export enum EMaterialsType {
  basic = 'basic',
  comfort = 'comfort',
  premium = 'premium',
}
